import { render, staticRenderFns } from "./HomePartner.vue?vue&type=template&id=8772748c&scoped=true"
import script from "./HomePartner.vue?vue&type=script&lang=js"
export * from "./HomePartner.vue?vue&type=script&lang=js"
import style0 from "./HomePartner.vue?vue&type=style&index=0&id=8772748c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8772748c",
  null
  
)

/* custom blocks */
import block0 from "./HomePartner.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports